// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"SectionG_TheComp__QCmQM"};